import { Filter } from '@/interfaces/filter.interface'
import { APIMessage } from '@/models/api/message.model'
import { MessagesServices } from '@/services/modules/messages.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class MessagesStore extends VuexModule {
    messages: object[] = []
    messagesPaginate: object[] = []
    messageForm: object|null = null

    @Mutation
    updateMessages (newMessages: object[]) {
        this.messages = newMessages
    }

    @Mutation
    updateMessagesPaginate (newMessages: object[]) {
        this.messagesPaginate = newMessages
    }

    @Mutation
    updateMessage (newMessage: object) {
        this.messageForm = newMessage
    }

    @Action
    getMessages () {
        return new Promise((resolve) => {
            MessagesServices.getMessages()
                .then(resp => {
                    store.commit('updateMessages', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getMessagesPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = { page: params.page, limit: params.limit, sortBy: params.sortBy, sort: params.sort }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            MessagesServices.getMessagesPaginate(newParams)
                .then(resp => {
                    store.commit('updateMessagesPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getMessagesById (id: number) {
        return new Promise((resolve) => {
            MessagesServices.getMessagesById(id)
                .then(resp => {
                    store.commit('updateMessage', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editMessages (params: APIMessage) {
        params = new APIMessage(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIMessage)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            MessagesServices.editMessages(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createMessages (params: APIMessage) {
        params = new APIMessage(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIMessage)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            MessagesServices.createMessages(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteMessages (id: number) {
        return new Promise((resolve) => {
            MessagesServices.deleteMessages(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    restoreMessages (id: number) {
        return new Promise((resolve) => {
            MessagesServices.restoreMessages(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
